<div mat-dialog-title fxLayoutAlign="space-between center">
  <h2>{{ ('dialog.pull-pre-auth.title.' + data.type)| translate }}</h2>
  <span fxFlex></span>
  <span *ngIf="data.appointment?.startAt" class="mr-3">
    {{ 'dialog.pull-pre-auth.dos' | translate: { value: data.appointment.startAt | momentDate } }}
  </span>
  <span *ngIf="procedureCodes.length > 0">
    CPTs: {{ procedureCodes.join(', ') }}
  </span>
</div>

<mat-progress-bar *ngIf="loading$ | async" mode="indeterminate" class="session-progress"></mat-progress-bar>

<mat-dialog-content>
  <form
    *ngIf="availableCarriers$ | async as carriers"
    fxLayout="column"
    [formGroup]="formGroup"
  >
    <ng-container *ngIf="(mode$ | async) === 'request'">
      <mat-form-field fxFlex>
        <mat-label>
          {{ 'service-review-inquiry.form.carrier' | translate }}
        </mat-label>
        <mat-select formControlName="carrier">
          <mat-option *ngFor="let carrier of carriers" [value]="carrier">
            {{ carrier.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field *ngIf="availableServiceTypes?.length > 1" fxFlex class="mb-3">
        <mat-label>
          {{ 'service-review-inquiry.form.request-type.label' | translate }}
        </mat-label>
        <mat-select formControlName="requestTypeCode">
          <mat-option *ngIf="availableServiceTypes?.includes(SUBTYPE.HEALTH_SERVICES)" [value]="SUBTYPE.HEALTH_SERVICES">Outpatient Authorizations / Health Services Review</mat-option>
          <mat-option *ngIf="availableServiceTypes?.includes(SUBTYPE.ADMISSION)" [value]="SUBTYPE.ADMISSION">Inpatient Authorizations / Admission Review</mat-option>
          <mat-option *ngIf="availableServiceTypes?.includes(SUBTYPE.REFERRALS)" [value]="SUBTYPE.REFERRALS">Referrals / Speciality Care Review</mat-option>
        </mat-select>
        <mat-hint>{{ 'service-review-inquiry.form.request-type.hint' | translate }}</mat-hint>
      </mat-form-field>

      <ng-container *ngIf="insuranceProviderConfigurationService.configuration$ | async as configuration">
        <mmx-service-review-inquiry-form
          *ngIf="(insuranceProviderConfigurationService.isLoading$ | async) === false"
          formControlName="priorAuthorization"
          [type]="data.type"
          [products]="data.products"
          [configuration]="configuration"
          [appointment]="data.appointment"
        ></mmx-service-review-inquiry-form>
      </ng-container>

      <div class="error-form" *ngIf="insuranceProviderConfigurationService.configurationError$ | async">
        {{ 'dialog.pull-pre-auth.configuration-error' | translate }}
      </div>

      <div class="loading-form" *ngIf="insuranceProviderConfigurationService.isLoading$ | async; else formEl">
        {{ 'dialog.pull-pre-auth.configuration-loading' | translate }}
      </div>
    </ng-container>

    <ng-container *ngIf="serviceReviews$ | async as serviceReviews">
      <mmx-prior-authorization-list
        *ngIf="resultsVisible$ | async"
        [serviceReviews]="serviceReviews"
        formControlName="serviceReviews"
      ></mmx-prior-authorization-list>
    </ng-container>
  </form>

  <ul *ngIf="serviceReviewErrors$ | async as errors" class="errors-list">
    <li *ngFor="let error of errors">{{ error.errorMessage }}</li>
  </ul>

  <ul *ngIf="noSelection" class="errors-list">
    <li>No selection has been made. Please select at least one item to import.</li>
  </ul>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center" fxLayoutAlign="space-between center">
  <button mat-flat-button mat-dialog-close>
    {{ 'dialog.pull-pre-auth.actions.cancel' | translate }}
  </button>
  <button
    *ngIf="mode$ | async as mode"
    mat-flat-button
    type="submit"
    color="primary"
    [disabled]="loading$ | async"
    (click)="onSubmit(mode)"
  >
    <ng-container *ngIf="(mode$ | async) === 'request'; else saveEl">
      {{ 'dialog.pull-pre-auth.actions.pull' | translate }}
    </ng-container>
    <ng-template #saveEl>
      {{ 'dialog.pull-pre-auth.actions.save' | translate }}
    </ng-template>
  </button>
</mat-dialog-actions>
